import { RecordRepository, RefBuilder } from '@framework/repository';
import { RTDBPath } from 'balus-common';
import { GroupMemberInvitation } from '@group/domain';
import type { GroupId } from 'balus-common';

/**
 * グループメンバー招待処理をUIから呼び出す際のエントリーポイント。
 *
 * 呼び出される際には成功する条件が揃った状態で呼び出されることを前提にする。
 * 失敗する時は例外的な状況なので、成功失敗のフィードバックは詳細をエンドユーザーには返さず、エラー検知システム側にだけフィードバックする。
 */
export class GroupMemberInvitationOperation {
  /**
   * グループメンバーの招待状を無効化します。
   * 失敗時は例外をスローします。成功時は何も返しません。
   *
   * @param invitation 招待情報
   */
  static async deactivate(invitation: GroupMemberInvitation): Promise<void> {
    await RefBuilder.ref(RTDBPath.Group.memberInvitationPath(invitation.groupId, invitation.id))
      .child('active')
      .set(false);
  }

  /**
   * 指定のグループに対する全てのグループメンバーの招待状を無効化します。
   * グループを論理削除する際に呼び出すことを想定しています。
   * 失敗時は例外をスローします。成功時は何も返しません。
   *
   * @param groupId グループID
   */
  static async allDeactivate(groupId: GroupId): Promise<void> {
    const repo = new RecordRepository(GroupMemberInvitation, RTDBPath.Group.memberInvitationsPath(groupId));
    const invitations = Object.values(await repo.get());

    // 現時点で招待受諾待ちの招待状を取り出す
    const pendingInvitations = invitations.filter((invitation) => invitation.isPending());

    await Promise.all(pendingInvitations.map((invitation) => this.deactivate(invitation)));
  }
}
